import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getLabelTpl,
  getIdLabelTpl,
  createLabelTpl,
  updateLabelTpl,
  deleteLabelTpl,
  getMstareatype,
  getIdMstareatype,
  createMstareatype,
  updateMstareatype,
  deleteMstareatype,
  getMstinspectcat,
  getIdMstinspectcat,
  createMstinspectcat,
  updateMstinspectcat,
  deleteMstinspectcat,
  getMstdamagecond,
  getIdMstdamagecond,
  createMstdamagecond,
  updateMstdamagecond,
  deleteMstdamagecond,
  getPreferences,
  getIdPreferences,
  createPreferences,
  updatePreferences,
  deletePreferences,
  postFile,
} from "./motorPoolAPI";
import createTransform from "redux-persist/es/createTransform";

const initialState = {
  data: [],
  dataId: null,
  dataAreaType: [],
  dataIdAreatype: null,
  dataMstinspectcat: [],
  dataIdMstinspectcat: null,
  dataMstdamagecond: [],
  dataIdMstdamagecond: null,
  dataPreferences: [],
  dataIdPreferences: null,
  loading: false,
  error: null,
  pageNo: 1,
  pageSize: 10,
  totalRecord: 0,
  totalRecordLabel: 0,
  totalRecordArea: 0,
  totalRecordDamage: 0,
  totalRecordInspection: 0,
  totalRecordPreferences: 0,
  selected: null,
  result: null,
  tabMaster: null,
  permissionsLabelTemplate: [],
  permissionsAreaType: [],
  permissionsDamage: [],
  permissionsCategory: [],
  permissionsPreference: [],
};

// Label

export const fetchLabelTpl = createAsyncThunk(
  "motorPool/fetchLabelTpl",
  async (payload) => {
    const response = await getLabelTpl(payload);
    return response;
  }
);

export const addLabelTpl = createAsyncThunk(
  "motorPool/addLabelTpl",
  async (payload) => {
    const response = await createLabelTpl(payload);
    return response;
  }
);

export const editLabelTpl = createAsyncThunk(
  "motorPool/editLabelTpl",
  async (payload) => {
    const response = await updateLabelTpl(payload);
    return response;
  }
);

export const fetchIdLabelTpl = createAsyncThunk(
  "motorPool/fetchIdLabelTpl",
  async (id) => {
    const response = await getIdLabelTpl(id);
    return response;
  }
);

export const removeLabelTpl = createAsyncThunk(
  "motorPool/removeLabelTpl",
  async (payload) => {
    const response = await deleteLabelTpl(payload);
    return response;
  }
);

export const uploadFile = createAsyncThunk(
  "motorPool/uploadFileLABEL",
  async ({ file_type, object_id, file }) => {
    console.log(file_type, object_id, file, "test");
    const response = await postFile(file_type, object_id, file);
    return response;
  }
);

// area Type
export const fetchMstareatype = createAsyncThunk(
  "motorPool/fetchMstareatype",
  async (payload) => {
    const response = await getMstareatype(payload);
    return response;
  }
);

export const addMstareatype = createAsyncThunk(
  "motorPool/addMstareatype",
  async (payload) => {
    const response = await createMstareatype(payload);
    return response;
  }
);

export const editMstareatype = createAsyncThunk(
  "motorPool/editMstareatype",
  async (payload) => {
    const response = await updateMstareatype(payload);
    return response;
  }
);

export const fetchIdMstareatype = createAsyncThunk(
  "motorPool/fetchIdMstareatype",
  async (id) => {
    const response = await getIdMstareatype(id);
    return response;
  }
);

export const removeMstareatype = createAsyncThunk(
  "motorPool/removeMstareatype",
  async (payload) => {
    const response = await deleteMstareatype(payload);
    return response;
  }
);

// Mstinspectcat
export const fetchMstinspectcat = createAsyncThunk(
  "motorPool/fetchMstinspectcat",
  async (payload) => {
    const response = await getMstinspectcat(payload);
    return response;
  }
);

export const addMstinspectcat = createAsyncThunk(
  "motorPool/addMstinspectcat",
  async (payload) => {
    const response = await createMstinspectcat(payload);
    return response;
  }
);

export const editMstinspectcat = createAsyncThunk(
  "motorPool/editMstinspectcat",
  async (payload) => {
    const response = await updateMstinspectcat(payload);
    return response;
  }
);

export const fetchIdMstinspectcat = createAsyncThunk(
  "motorPool/fetchIdMstinspectcat",
  async (id) => {
    const response = await getIdMstinspectcat(id);
    return response;
  }
);

export const removeMstinspectcat = createAsyncThunk(
  "motorPool/removeMstinspectcat",
  async (payload) => {
    const response = await deleteMstinspectcat(payload);
    return response;
  }
);

// Mstdamagecond
export const fetchMstdamagecond = createAsyncThunk(
  "motorPool/fetchMstdamagecond",
  async (payload) => {
    const response = await getMstdamagecond(payload);
    return response;
  }
);

export const addMstdamagecond = createAsyncThunk(
  "motorPool/addMstdamagecond",
  async (payload) => {
    const response = await createMstdamagecond(payload);
    return response;
  }
);

export const editMstdamagecond = createAsyncThunk(
  "motorPool/editMstdamagecond",
  async (payload) => {
    const response = await updateMstdamagecond(payload);
    return response;
  }
);

export const fetchIdMstdamagecond = createAsyncThunk(
  "motorPool/fetchIdMstdamagecond",
  async (id) => {
    const response = await getIdMstdamagecond(id);
    return response;
  }
);

export const removeMstdamagecond = createAsyncThunk(
  "motorPool/removeMstdamagecond",
  async (payload) => {
    const response = await deleteMstdamagecond(payload);
    return response;
  }
);

// Preferences
export const fetchPreferences = createAsyncThunk(
  "motorPool/fetchPreferences",
  async (payload) => {
    const response = await getPreferences(payload);
    return response;
  }
);

export const addPreferences = createAsyncThunk(
  "motorPool/addPreferences",
  async (payload) => {
    const response = await createPreferences(payload);
    return response;
  }
);

export const editPreferences = createAsyncThunk(
  "motorPool/editPreferences",
  async (payload) => {
    const response = await updatePreferences(payload);
    return response;
  }
);

export const fetchIdPreferences = createAsyncThunk(
  "motorPool/fetchIdPreferences",
  async (id) => {
    const response = await getIdPreferences(id);
    return response;
  }
);

export const removePreferences = createAsyncThunk(
  "motorPool/removePreferences",
  async (payload) => {
    const response = await deletePreferences(payload);
    return response;
  }
);

export const motorPoolSlice = createSlice({
  name: "motorPool",
  initialState,
  reducers: {
    resetData: () => initialState,
    setSelected: (state, action) => {
      state.selected = action.payload;
    },
    setTabMaster: (state, action) => {
      state.tabMaster = action.payload;
    },
    setPermisionLabelTemplate: (state, action) => {
      state.permissionsLabelTemplate = action.payload;
    },
    setPermisionAreaType: (state, action) => {
      state.permissionsAreaType = action.payload;
    },
    setPermisionDamage: (state, action) => {
      state.permissionsDamage = action.payload;
    },
    setPermisionCategory: (state, action) => {
      state.permissionsCategory = action.payload;
    },
    setPermisionPreference: (state, action) => {
      state.permissionsPreference = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchLabelTpl.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchLabelTpl.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data.data;
        state.pageNo = action.payload.data.pageNo;
        state.pageSize = action.payload.data.pageSize;
        state.totalRecord = action.payload.data.totalRecord;
        state.totalRecordLabel = action.payload.data.totalRecord;
      })
      .addCase(fetchIdLabelTpl.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchIdLabelTpl.fulfilled, (state, action) => {
        state.loading = false;
        state.dataId = action.payload.data.data;
      })

      .addCase(addLabelTpl.pending, (state) => {
        state.loading = true;
      })
      .addCase(addLabelTpl.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })

      .addCase(editLabelTpl.pending, (state) => {
        state.loading = true;
      })
      .addCase(editLabelTpl.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(removeLabelTpl.pending, (state) => {
        state.loading = true;
      })
      .addCase(removeLabelTpl.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      // areaType
      .addCase(fetchMstareatype.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchMstareatype.fulfilled, (state, action) => {
        state.loading = false;
        state.dataAreaType = action.payload.data.data;
        state.pageNo = action.payload.data.pageNo;
        state.pageSize = action.payload.data.pageSize;
        state.totalRecord = action.payload.data.totalRecord;
        state.totalRecordArea = action.payload.data.totalRecord;
      })
      .addCase(fetchIdMstareatype.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchIdMstareatype.fulfilled, (state, action) => {
        state.loading = false;
        state.dataIdAreatype = action.payload.data.data;
      })

      .addCase(addMstareatype.pending, (state) => {
        state.loading = true;
      })
      .addCase(addMstareatype.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })

      .addCase(editMstareatype.pending, (state) => {
        state.loading = true;
      })
      .addCase(editMstareatype.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(removeMstareatype.pending, (state) => {
        state.loading = true;
      })
      .addCase(removeMstareatype.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })

      // Mstinspectcat
      .addCase(fetchMstinspectcat.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchMstinspectcat.fulfilled, (state, action) => {
        state.loading = false;
        state.dataMstinspectcat = action.payload.data.data;
        state.pageNo = action.payload.data.pageNo;
        state.pageSize = action.payload.data.pageSize;
        state.totalRecord = action.payload.data.totalRecord;
        state.totalRecordInspection = action.payload.data.totalRecord;
      })
      .addCase(fetchIdMstinspectcat.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchIdMstinspectcat.fulfilled, (state, action) => {
        state.loading = false;
        state.dataIdMstinspectcat = action.payload.data.data;
      })

      .addCase(addMstinspectcat.pending, (state) => {
        state.loading = true;
      })
      .addCase(addMstinspectcat.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })

      .addCase(editMstinspectcat.pending, (state) => {
        state.loading = true;
      })
      .addCase(editMstinspectcat.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(removeMstinspectcat.pending, (state) => {
        state.loading = true;
      })
      .addCase(removeMstinspectcat.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })

      // Mstdamagecond
      .addCase(fetchMstdamagecond.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchMstdamagecond.fulfilled, (state, action) => {
        state.loading = false;
        state.dataMstdamagecond = action.payload.data.data;
        state.pageNo = action.payload.data.pageNo;
        state.pageSize = action.payload.data.pageSize;
        state.totalRecord = action.payload.data.totalRecord;
        state.totalRecordDamage = action.payload.data.totalRecord;
      })
      .addCase(fetchIdMstdamagecond.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchIdMstdamagecond.fulfilled, (state, action) => {
        state.loading = false;
        state.dataIdMstinspectcat = action.payload.data.data;
      })

      .addCase(addMstdamagecond.pending, (state) => {
        state.loading = true;
      })
      .addCase(addMstdamagecond.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })

      .addCase(editMstdamagecond.pending, (state) => {
        state.loading = true;
      })
      .addCase(editMstdamagecond.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(removeMstdamagecond.pending, (state) => {
        state.loading = true;
      })
      .addCase(removeMstdamagecond.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })

      // Preferences
      .addCase(fetchPreferences.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchPreferences.fulfilled, (state, action) => {
        state.loading = false;
        state.dataPreferences = action.payload.data.data;
        state.pageNo = action.payload.data.pageNo;
        state.pageSize = action.payload.data.pageSize;
        state.totalRecord = action.payload.data.totalRecord;
        state.totalRecordPreferences = action.payload.data.totalRecord;
      })
      .addCase(fetchIdPreferences.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchIdPreferences.fulfilled, (state, action) => {
        state.loading = false;
        state.dataIdPreferences = action.payload.data.data;
      })

      .addCase(addPreferences.pending, (state) => {
        state.loading = true;
      })
      .addCase(addPreferences.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })

      .addCase(editPreferences.pending, (state) => {
        state.loading = true;
      })
      .addCase(editPreferences.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(removePreferences.pending, (state) => {
        state.loading = true;
      })
      .addCase(removePreferences.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      });
  },
});

export const {
  resetData,
  setSelected,
  setTabMaster,
  setPermisionLabelTemplate,
  setPermisionAreaType,
  setPermisionCategory,
  setPermisionDamage,
  setPermisionPreference,
} = motorPoolSlice.actions;
//area type
export const selectMstareatype = (state) => state.motorPool.dataAreaType;
export const selectIdMstareatype = (state) => state.motorPool.dataIdAreatype;
export const selectLabelTpl = (state) => state.motorPool.data;
export const selectIdLabelTpl = (state) => state.motorPool.dataId;
export const selectMstinspectcat = (state) => state.motorPool.dataMstinspectcat;
export const selectIdMstinspectcat = (state) =>
  state.motorPool.dataIdMstinspectcat;
export const selectMstdamagecond = (state) => state.motorPool.dataMstdamagecond;
export const selectIdMstdamagecond = (state) =>
  state.motorPool.dataIdMstdamagecond;

export const selectPreferences = (state) => state.motorPool.dataPreferences;
export const selectIdPreferences = (state) => state.motorPool.dataIdPreferences;
export const selectLoading = (state) => state.motorPool.loading;
export const selectError = (state) => state.motorPool.error;
export const selectPageNo = (state) => state.motorPool.pageNo;
export const selectPageSize = (state) => state.motorPool.pageSize;
export const selectTotalRecord = (state) => state.motorPool.totalRecord;
export const selectTotalRecordLabel = (state) =>
  state.motorPool.totalRecordLabel;
export const selectTotalRecordArea = (state) => state.motorPool.totalRecordArea;
export const selectTotalRecordDamage = (state) =>
  state.motorPool.totalRecordDamage;
export const selectTotalRecordInspection = (state) =>
  state.motorPool.totalRecordInspection;
export const selectTotalRecordPreferences = (state) =>
  state.motorPool.totalRecordPreferences;
export const selectSelected = (state) => state.motorPool.selected;
export const selectResult = (state) => state.motorPool.result;
export const selectTabMaster = (state) => state.motorPool.tabMaster;
export const selectPermissionLabelTemplate = (state) =>
  state.motorPool.permissionsLabelTemplate;

export const selectPermissionAreaType = (state) =>
  state.motorPool.permissionsAreaType;

export const selectPermissionDamage = (state) =>
  state.motorPool.permissionsDamage;

export const selectPermissionCategory = (state) =>
  state.motorPool.permissionsCategory;

export const selectPermissionPreference = (state) =>
  state.motorPool.permissionsPreference;

export default motorPoolSlice.reducer;
